import { Component, inject, OnInit } from '@angular/core';
import { HeaderComponent } from "../../../layout/header/header.component";
import { FooterComponent } from "../../../layout/footer/footer.component";
import { JobService } from '../../../core/services/job/job.service';
import { Job, JobDetails } from '../../../core/models/job.model';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { lastValueFrom, Observable } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-job-openings',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, CommonModule, MatProgressSpinnerModule],
  templateUrl: './job-openings.component.html',
  styleUrl: './job-openings.component.scss'
})
export class JobOpeningsComponent implements OnInit{
  jobDetails: JobDetails[] = [];
  loading: boolean = true;
  error: string | null = null;

  private jobService = inject(JobService);
  private router = inject(Router);

  ngOnInit(): void {
    this.getJobsAndJobDetails();
  }

  async getJobsAndJobDetails(): Promise<void> {
    this.loading = true;
    this.error = null;

    try {
      const result: Job = await lastValueFrom(this.jobService.getJobs());

      if (result.success && result.data) {
        this.jobDetails = result.data;
      } else {
        this.error = result.message || "Failed to retrieve job data from API.";
        console.error("API reported failure:", result.message);
      }
    } catch (err) {
      console.error("Error fetching job details:", err);
      this.error = "An error occurred while fetching job details. Please try again.";
    } finally {
      this.loading = false;
    }
  }

  viewDetails(id: string): void {
    this.router.navigate(['/job'], { queryParams: { id } });
  }
}
